// Feature Documentation: docs/features/pilot-user-workflow.md
import React from 'react';
import { Box, Heading, Text, VStack, Container } from '@chakra-ui/react';
import HeaderMenus from './HeaderMenus';

const PilotPlaceholder = () => {
  return (
    <Box minH="100vh" bg="gray.50">
      <HeaderMenus />
      <Container maxW="container.md" py={20}>
        <Box 
          p={8} 
          borderWidth={1} 
          borderRadius="lg" 
          boxShadow="lg" 
          bg="white"
          textAlign="center"
        >
          <VStack spacing={6}>
            <Heading size="lg" color="brand.700">
              Pilot Phase 1
            </Heading>
            <Text fontSize="lg" color="gray.600">
              Please contact your pilot administrator for access to this view.
            </Text>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default PilotPlaceholder;